import { useClusterId, useTenantId } from '@/core/appMeta';

export const getSchemaUrl = (tag: string, isPublic?: boolean) => {
	const clusterId = useClusterId();
	const tenantId = useTenantId();

	return `json-ir://${isPublic ? 'public' : tenantId}@${clusterId}/${tag}`;
};
